// extracted by mini-css-extract-plugin
module.exports = {"buttonActive":"styles_buttonActive__Vk4vu","button":"styles_button__jibA6","triggerPlaceholderNodeIcon":"styles_triggerPlaceholderNodeIcon__ptg0L"};